module.exports = __webpack_public_path__ + "static/media/website-setp-img-3.77a02347.png";